"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _hooks = require("../../hooks");
var _SceneLayoutChooserItemLightTheme = require("./SceneLayoutChooserItemLightTheme.styled");
var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));
var _propComparators = require("../../utils/propComparators");
var _SceneLayerChooserUtils = require("./SceneLayerChooserUtils");
var _ = require("./..");
var _useTranslate2 = require("../../locales/useTranslate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SceneLayoutChooserItemLightTheme = function SceneLayoutChooserItemLightTheme(_ref) {
  var title = _ref.title,
    styles = _ref.styles,
    onClick = _ref.onClick,
    selected = _ref.selected,
    available = _ref.available,
    layoutIndex = _ref.layoutIndex,
    layoutId = _ref.id,
    isLayoutStaged = _ref.isLayoutStaged;
  (0, _hooks.useHotKeys)("".concat(layoutIndex), onClick);
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var targetElementId = "layout-chooser-".concat(layoutIndex);
  var LayoutUnavailableTooltip = function LayoutUnavailableTooltip(_ref2) {
    var layoutId = _ref2.layoutId,
      available = _ref2.available,
      layoutIndex = _ref2.layoutIndex;
    var toolTipText = _SceneLayerChooserUtils.featuredLayoutIdToText[layoutId];
    if (available) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
      placement: "bottom",
      targetElement: "layout-chooser-".concat(layoutIndex),
      message: translate(toolTipText)
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SceneLayoutChooserItemLightTheme.Wrapper, {
    styles: styles,
    onClick: onClick,
    selected: selected,
    id: targetElementId,
    available: available,
    "data-testid": "scene-layout-selector-".concat(title),
    "aria-labelledby": "".concat(selected ? "".concat(title, "LayoutSelected") : "".concat(title, "Layout")),
    role: "button",
    "data-dd-action-name": "".concat(title, " layout")
  }, isLayoutStaged && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    id: title,
    checked: isLayoutStaged,
    dataTestId: "stage-layout"
  })), /*#__PURE__*/_react["default"].createElement(LayoutUnavailableTooltip, {
    layoutId: layoutId,
    available: available,
    layoutIndex: layoutIndex
  }));
};
var StyleShape = (0, _propTypes.shape)({
  thumbnail: _propTypes.string.isRequired
});
SceneLayoutChooserItemLightTheme.propTypes = {
  id: _propTypes.string,
  available: _propTypes.bool,
  layoutId: _propTypes.string,
  layoutIndex: _propTypes.number,
  isLayoutStaged: _propTypes.bool,
  styles: (0, _propTypes.shape)({
    hover: StyleShape,
    focus: StyleShape,
    active: StyleShape,
    "default": StyleShape,
    disabled: StyleShape
  }),
  targetElementId: _propTypes.string,
  title: _propTypes.string.isRequired,
  onClick: _propTypes.func.isRequired,
  selected: _propTypes.bool.isRequired,
  selectLayoutHandler: _propTypes.func
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SceneLayoutChooserItemLightTheme, _propComparators.equalityComparator);